import styled from 'styled-components';

import { ACQ } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 16px;
  font-weight: 700;
  color: ${ACQ.t300};
`;

/** "Spent" prefix — sits a hair before the figure (no gap inside "$42/$50"). */
export const SpentLabel = styled(Text)`
  margin-right: 5px;
`;

export const Spent = styled.span`
  color: ${ACQ.t300};
`;

export const Budget = styled.span`
  color: ${ACQ.spentDim};
`;
